import { render, staticRenderFns } from "./GiftWish.vue?vue&type=template&id=24d366e6&"
import script from "./GiftWish.vue?vue&type=script&lang=js&"
export * from "./GiftWish.vue?vue&type=script&lang=js&"
import style0 from "./GiftWish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports